import feathers from '@feathersjs/feathers';
import { userApi } from '_/services/api';
import {
  getUserCompaniesRequest,
  setUserCurrentCompanyRequest,
} from '_/store/modules/company/actions';
import React, { createContext, useCallback, useContext, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSocket } from './useSocket';

interface UserContextData {
  feathersApp: feathers.Application | undefined;
}

const UserContext = createContext<UserContextData>({} as UserContextData);

type UserType = {
  children: React.ReactNode;
};

export const UserProvider: React.FC<UserType> = ({ children }) => {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();

  const [feathersApp, setFeathersApp] = useState<feathers.Application>();
  const { initSocket, closeSocket } = useSocket();

  const reconnectTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!user.id) {
      closeSocket();
      return;
    }

    if (reconnectTimeout.current) {
      clearTimeout(reconnectTimeout.current);
    }

    closeSocket();

    reconnectTimeout.current = setTimeout(() => {
      const app = initSocket(user.id);
      setFeathersApp(app);
    }, 300);

    return () => {
      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
      }
      closeSocket();
    };
  }, [user.id, user.currentCompanyId]);

  useEffect(() => {
    if (user.id) {
      dispatch(getUserCompaniesRequest());
      getCurrentCompany();
    }
  }, [user.id]);

  async function getCurrentCompany() {
    const { currentCompanyId } = await userApi.getUser(user.id);

    const userCompany = user.companies.find((company: any) => company.id === currentCompanyId);

    dispatch(setUserCurrentCompanyRequest(userCompany, false));
  }

  // useEffect(() => {
  //   feathersApp?.service('users').on('patched', changeCurrentCompany);
  //
  //   return () => {
  //     feathersApp?.service('users').off('patched', changeCurrentCompany);
  //   };
  // }, [feathersApp, changeCurrentCompany]);

  return <UserContext.Provider value={{ feathersApp }}>{children}</UserContext.Provider>;
};

export function useUser() {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUser must be used within an UserProvider');
  }

  return context;
}
